import {
  Avatar,
  Select,
  InputLabel,
  TextField,
  MenuItem,
  Button,
  Fab,
  Fade,
  FormControl,
  IconButton,
  Paper,
  Slide,
  Typography } from '@material-ui/core';
import { createTheme, MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Send from '@material-ui/icons/Send';
import ClearIcon from '@material-ui/icons/Clear';
import TrashIcon from '@material-ui/icons/Delete';
import ReplayIcon from '@material-ui/icons/Replay';
import Print from '@material-ui/icons/Print';
import Search from '@material-ui/icons/Search';
import { format, parse } from 'date-fns';
import MUIDataTable from 'mui-datatables';
import React from 'react';
import { Link } from 'react-router-dom';
import FaturaApi from '../../api/FaturaApi';
import { withAplicacao } from '../../contexts/AplicacaoContext';
import { withUsuario } from '../../contexts/UsuarioContext';
import IntegrationAutosuggest from '../share/IntegrationAutosuggest';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import LongMenu from '../share/LongMenu';
import VariantSnackbar from '../share/VariantSnackbar';
import Delete from '@material-ui/icons/Delete';
import PrestadorApi from '../../api/PrestadorApi';
import FilterBeneficiario from '../share/FilterBeneficiario';
import ArquivoXMLApi from '../../api/ArquivoXMLApi';
import FullScreenProtocolo from './FullScreenProtocolo';
import ToolbarNovo from './ToolbarNovo';
import FormDialogLoteRecurso from './FormDialogLoteRecurso';
import DialogErrosDemonstrativos from '../financeiro/DialogErrosDemonstrativos';
import AlertDialogSlide from '../share/AlertDialogSlide';

const styles = theme => ({
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    marginLeft: '20px',
    fontSize: 12
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  textFieldFilter: {
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 180,
  },
  formControlAutoCompleteLote: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    minWidth: 210,
  },  
  formControlAutoCompleteFatura: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    minWidth: 210,
  },  
  formControlAutoCompleteDemonstrativo: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    minWidth: 210,
  },  
  formControlAutoCompletePrestador: {
    margin: theme.spacing(1),
    minWidth: 610,
  },
  formControlAutoCompleteBeneficiario: {
    marginLeft: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    minWidth: 230,
  },  
  selectTipoGuia: {
    margin: theme.spacing(1),
    minWidth: 280,
  },  
  selectEstadoProtocolo: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(6),
    minWidth: 320,
  },  
  selectTipoLote: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(6),
    minWidth: 320,
  },  
  buttonConsultar: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
    width: '95px'
  },
  buttonLimpar: {
    marginTop: theme.spacing(1.5),
    marginLeft: theme.spacing(0.5),
    width: '95px'
  },  
  tableRowCancelado: {
    backgroundColor: '#f2dede',
  },  
});
const getMuiTheme = () =>
  createTheme({
    overrides: {
      MuiTableCell: {
        root: {
          padding: '5px',
        },
      },
    }
  });

class LoteRecursoGlosa extends React.Component {
  faturaApi = new FaturaApi();
  prestadorApi = new PrestadorApi();
  arquivoXMLApi = new ArquivoXMLApi();
  state = {
    lotes: [],
    nomesLotes: [],
    loteSelected: {},
    codLoteSelected: 0,
    numProtocoloSelected: '',
    numGuiaPrestadorSelected: '',
    numGuiaOperadoraSelected: '',  
    numSenhaAutorizacaoSelected: '',
    codFaturaSelected: 0,
    nomesFaturas: [],
    numDemonstrativoFiltroSelected: 0,
    numerosDemostrativos: [],
    nomesPrestadores: [],
    seqPrestadorSelected: this.props.codPrestador === undefined ? 0 : this.props.codPrestador, 
    nomePrestadorSelected: this.props.nomPrestador === undefined ? '' : this.props.nomPrestador,
    nomesBeneficiarios: [],
    numCarteiraTstSelected: '',
    codTipoGuiaSelected: 0,
    codEstadoProtocoloSelected: 99,
    codTipoLoteSelected: 0,
    protocolo: [],

    snackOpen: false,
    snackMessage: '',
    snackSucesso: false,

    fetchingFilter: false,
    fetching: false,

    anchorEl: null,
    fullScreenProtocoloOpen: false,
    openDialogLote: false, 
    tituloFormDialog: '',
    modoInclusao: false, 
    openDialogValidacao: false,
    demonstrativosSemErros: [],
    openDialogExclusao: false,
    openDialogEnvioFaturamento: false,
    openDialogCancelamento: false,
    openDialogDesfazerCancelamento: false,
    modoCancelamento: true,
    dialogTitleCancelamento: '',
    dialogMessageCancelamento: '',
  }
  componentDidMount = async () => {
    this.setState({fetchingFilter: true});
    const nomesLotes = await this.props.getLotesRecurso();
    const nomesFaturas = await this.props.getFaturas();
    const numerosDemostrativos = await this.props.getDemonstrativos();
    const nomesPrestadores = await this.prestadorApi.consultarNomesTodosPrestadoresCredenciados();
    const nomesBeneficiarios = await this.props.getBeneficiarios();

    this.setState({
      nomesLotes: nomesLotes,
      nomesFaturas: nomesFaturas,
      numerosDemostrativos: numerosDemostrativos,
      nomesPrestadores: nomesPrestadores,
      seqPrestadorSelected: this.props.codPrestador === undefined ? 0 : this.props.codPrestador,
      nomePrestadorSelected: this.props.nomPrestador,
      nomesBeneficiarios: nomesBeneficiarios,
      fetchingFilter: false});
  }  
  handleChange = event => {    
    if (event.target.name === 'numProtocoloSelected' || 
        event.target.name === 'numGuiaPrestadorSelected' ||
        event.target.name === 'numGuiaOperadoraSelected' ||
        event.target.name === 'numSenhaAutorizacaoSelected'           
        ) {
      this.setState({ [event.target.name]: event.target.value.toUpperCase().substring(0, 20) });
    } else {
      this.setState({ [event.target.name]: event.target.value });
    }
  }
  getSuggestionValueLote = (suggestion, id) => {
    this.setState({
      codLoteSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  getSuggestionValueFatura = (suggestion, id) => {
    this.setState({
      codFaturaSelected: id !== undefined ? id : suggestion.id,
    });
    return suggestion.nome;
  }
  getSuggestionValueDemonstrativo = (suggestion, id) => {        
    this.setState({numDemonstrativoFiltroSelected: id !== undefined ? id : suggestion.id});
    return suggestion.nome;
  }
  getSuggestionValuePrestador = (suggestion, id) => {
    this.setState({seqPrestadorSelected: id !== undefined ? id : suggestion.id});
    return suggestion.nome;
  }
  handleSelectBeneficiario = (carteira) => {
    this.setState({
      numCarteiraTstSelected: carteira,
    });
  }
  handleClickLimparCarteira () {
    this.handleSelectBeneficiario('', '');
  }
  handleClickLimpar = async () => {
    this.setState({fetchingFilter: true});
    await this.setState({  
      codLoteSelected: 0,
      numProtocoloSelected: '',
      numGuiaPrestadorSelected: '',
      numGuiaOperadoraSelected: '',  
      numSenhaAutorizacaoSelected: '',
      codFaturaSelected: 0,
      numDemonstrativoFiltroSelected: 0,
      seqPrestadorSelected: this.props.codPrestador === undefined ? 0 : this.props.codPrestador, 
      nomePrestadorSelected: this.props.nomPrestador === undefined ? '' : this.props.nomPrestador,
      numCarteiraTstSelected: '',
      codTipoGuiaSelected: 0,
      codEstadoProtocoloSelected: 99,
      codTipoLoteSelected: 0,
    });
    this.setState({fetchingFilter: false});    
  }  

  preencheuAlgumFiltro = () => {
    return !(
      this.state.codLoteSelected === 0 &&
      this.state.numProtocoloSelected === '' &&
      this.state.numGuiaPrestadorSelected === '' &&
      this.state.numGuiaOperadoraSelected === '' &&
      this.state.numSenhaAutorizacaoSelected === '' &&
      this.state.codFaturaSelected == 0 &&
      this.state.numDemonstrativoFiltroSelected == 0 &&
      this.state.seqPrestadorSelected === 0 &&
      this.state.numCarteiraTstSelected === '' &&
      this.state.codTipoGuiaSelected === 0 &&
      this.state.codEstadoProtocoloSelected === 99 &&
      this.state.codTipoLoteSelected === 0
      );
  }  
  consultar = async () => {
    this.setState({fetching: true});
    if (this.preencheuAlgumFiltro()) {
      const lotes = await this.faturaApi.consultarLotesRecursoPorPrestadorCodigoStatus(
        this.state.seqPrestadorSelected,
        this.state.numCarteiraTstSelected,
        this.state.codFaturaSelected,
        this.state.numGuiaPrestadorSelected,
        this.state.numGuiaOperadoraSelected,
        this.state.numSenhaAutorizacaoSelected,
        this.state.codEstadoProtocoloSelected,
        this.state.codLoteSelected,
        this.state.numProtocoloSelected,
        this.state.numDemonstrativoFiltroSelected,
        this.state.codTipoGuiaSelected,
        this.state.codTipoLoteSelected,
        'S'
        );    
        this.setState({lotes: lotes, fetching: false});
    } else {
      this.setState({fetching: false, snackOpen: true, snackMessage: 'Favor preencher pelo menos um filtro.', snackSucesso: false, loteSelected: {}, lotes: []});
      await this.handleClickLimpar();
    }
  }  
  handleClickBuscar = async () => {
    this.consultar();
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleClickMenu = (event, tableMeta) => {
    const loteSelecionado = {
      codLoteGuia: this.state.lotes[tableMeta.rowIndex][0], 
      numLotePrestador: this.state.lotes[tableMeta.rowIndex][1], 
      txtNumeroFatura: this.state.lotes[tableMeta.rowIndex][2], 
      nomTipoGuia: this.state.lotes[tableMeta.rowIndex][3], 
      cpfCnpjPrestador: this.state.lotes[tableMeta.rowIndex][4], 
      nomPrestador: this.state.lotes[tableMeta.rowIndex][5], 
      dtaRecebimentoProtocolo: format(parse(this.state.lotes[tableMeta.rowIndex][6]), 'DD/MM/YYYY'), 
      valTotalProcessado: this.state.lotes[tableMeta.rowIndex][7], 
      valTotalGlosado: this.state.lotes[tableMeta.rowIndex][8], 
      situacao: this.state.lotes[tableMeta.rowIndex][9], 
      indCancelado: this.state.lotes[tableMeta.rowIndex][10], 
      motivoCancelamento: this.state.lotes[tableMeta.rowIndex][11], 
      numProtocolo: this.state.lotes[tableMeta.rowIndex][12],
      numDemonstrativoPag: this.state.lotes[tableMeta.rowIndex][15],    
      valTotalLiberado: this.state.lotes[tableMeta.rowIndex][16], 
      numDemonstrativoPagRecorrido: this.state.lotes[tableMeta.rowIndex][17], 
      dtaFimRecGlosa: format(parse(this.state.lotes[tableMeta.rowIndex][18]), 'DD/MM/YYYY'), 
      indLoteRecursoAuditadoPapel: this.state.lotes[tableMeta.rowIndex][19], 
      historicoEstados: this.state.lotes[tableMeta.rowIndex][20], 
      numProtocoloRecorrido: this.state.lotes[tableMeta.rowIndex][21],
      codTipoGuia: this.state.lotes[tableMeta.rowIndex][22],
    };

    this.setState({ anchorEl: event.currentTarget, loteSelected: loteSelecionado });
  }
  handleCloseMenu = () => {
    this.setState({ anchorEl: null });
  }
  handleChangeMenu = async (index) => {
    this.setState({ anchorEl: null });
    if (index === 0) {    
      if (this.state.loteSelected.situacao !== 'NÃO ENVIADO' && this.state.loteSelected.numProtocolo !== null){
        this.imprimirProtocolo();
      } else {
        this.setState({fetching: false, snackOpen: true, snackMessage: 'Não foi possível realizar esta operação. O Lote está na situação ' + this.state.loteSelected.situacao + ' ou não possui um protocolo de envio.', snackSucesso: false, loteSelected: {}});        
      }
    }
    if (index === 1) {
      await this.visualizarLote();
    }
    if (index === 2) {
      if (this.state.loteSelected.situacao === 'NÃO ENVIADO' && this.state.loteSelected.indCancelado === 'N'){
        this.enviarParaFaturamento();
      } else {
        this.setState({fetching: false, snackOpen: true, snackMessage: 'Não foi possível realizar esta operação. O Lote está na situação ' + this.state.loteSelected.situacao + ' ou está cancelado.', snackSucesso: false, loteSelected: {}});        
      }            
    }
    if (index === 3) {
      if (this.state.loteSelected.situacao === 'NÃO ENVIADO'){
        this.setState({openDialogExclusao: true, dialogTitle: 'Exclusão de Lote de Recurso', dialogMessage: 'Apenas o lote ' + this.state.loteSelected.numLotePrestador + ' será excluído. Digite o CPF/CNPJ do prestador'})
      } else {
        this.setState({fetching: false, snackOpen: true, snackMessage: 'Não foi possível realizar esta operação. O Lote está na situação ' + this.state.loteSelected.situacao + '.', snackSucesso: false, loteSelected: {}});        
      }      
    }
  }  
  imprimirProtocolo = async () => {
    this.setState({ fetching: true });
    let filter = {
      numProtocolo: this.state.loteSelected.numProtocolo === '' ? 'vazio' : this.state.loteSelected.numProtocolo,
      seqPrestador: 0,
      nomePrestador: 'vazio',
      dataInicio: parse(new Date(0)),
      dataFim: parse(new Date()),
      indReapresentacao: 'S'
    }
    let protocolo = await this.arquivoXMLApi.listarProtocolos(filter);
    this.setState({ fullScreenProtocoloOpen: true, protocolo: protocolo[0], fetching: false });
  }
  visualizarLote = async () => {
    this.setState({openDialogLote: true, 
      tituloFormDialog: 'Visualizar Lote de Recurso - ' + this.state.loteSelected.numLotePrestador,
      fetching: false, modoInclusao: false});
  }  

  enviarParaFaturamento = () => {
    this.setState({openDialogEnvioFaturamento: true, 
      dialogTitle: 'Envio de Lote para Faturamento', 
      dialogMessage: 'Confirma o envio do lote ' + this.state.loteSelected.numLotePrestador + ' para faturamento?'});
  }  

  handleCloseProtocolo = () => {
    this.setState({ fullScreenProtocoloOpen: false });
  };  
  handleClickIncluir = async () => {
    this.setState({openDialogLote: true, tituloFormDialog: 'Inclusão de Lote de Recurso de Glosa', loteSelected: {}, modoInclusao: true});
    await this.handleClickLimpar();
  }
  handleDialogLoteClose = async () => {
    this.setState({openDialogLote: false});
  }

  incluirLote = async (lote) => {
    this.setState({fetching: true});
    let result = await this.faturaApi.incluirLoteRecurso(lote);    
    let numLoteNovo = 0;

    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {
      this.handleClickLimpar();
      let nomesLotes = this.state.nomesLotes.slice();
      let novoLote = {id: Number(result.data.registrosSemErros[0]), nome: lote.numLoteRecurso};
      numLoteNovo = Number(result.data.registrosSemErros[0]);
      nomesLotes.push(novoLote);
      this.setState({nomesLotes: nomesLotes, codLoteSelected: Number(result.data.registrosSemErros[0])});
      await this.consultar();
    } else {
      await this.setState({codLoteSelected: 0, demonstrativos: []});
    }      
    await this.onOperacaoFinalizada(result);    
    return numLoteNovo;
  }

  onOperacaoFinalizada = async (result) => {
    if (result === undefined || result.data === undefined) {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. Favor tentar novamente.',
        fetching: false,
        snackSucesso: false});
    } else {
      if (result.data.codigoRetorno === 1) {
        this.setState({ snackOpen: true,
          snackMessage: result.data.msgRetornoResumida,
          snackSucesso: true,
          fetching: false});
      } else {
        this.setState({
          openDialogValidacao: true,
          dialogContent: result.data.registrosComErros,
          dialogTitle: result.data.msgRetornoResumida,
          registrosSemErros: result.data.registrosSemErros,
          fetching: false});
      }
    }
  }  

  handleDialogValidacaoClose = () => {
    this.setState({openDialogValidacao: false});
  }

  handleCloseDialogExclusao = () => {
    this.setState({ openDialogExclusao: false });
  }

  handleCloseDialogEnvioFaturamento = () => {
    this.setState({ openDialogEnvioFaturamento: false });
  }    

  handleDialogConfirmExclusao = async (motivoOuCpfCnpj) => {
    this.setState({ openDialogExclusao: false, fetching: true });

    let lotes = [];
    lotes.push(this.state.loteSelected.codLoteGuia);

    let result;
    result = await this.faturaApi.excluirFaturasEmLote(lotes, motivoOuCpfCnpj);
    this.onOperacaoFinalizada(result);
    await this.consultar();
    this.setState({fetching: false});
  }  

  handleDialogConfirmEnvioFaturamento = async () => {
    this.setState({ openDialogEnvioFaturamento: false, fetching: true });
    let result = await this.faturaApi.envioFaturamento(this.state.loteSelected.codLoteGuia, this.state.loteSelected.numLotePrestador);
    this.onOperacaoFinalizada(result);    
    if (result !== undefined && result.data !== undefined && result.data.codigoRetorno === 1) {    
      let filter = {
        numProtocolo: result.data.registrosSemErros[0],
        seqPrestador: 0,
        nomePrestador: 'vazio',
        dataInicio: parse(new Date(0)),
        dataFim: parse(new Date()),
        indReapresentacao: 'S'
      }
      let protocolo = await this.arquivoXMLApi.listarProtocolos(filter);
      this.setState({ fullScreenProtocoloOpen: true, protocolo: protocolo[0], fetching: false });
      await this.consultar();
    } else {
      this.setState({fetching: false});
    }
  }  

  handleClickCancelar = (event, tableMeta) => {
    const loteSelecionado = {
      codLote: this.state.lotes[tableMeta.rowIndex][0],
      numLotePrestador: this.state.lotes[tableMeta.rowIndex][1],       
      situacao: this.state.lotes[tableMeta.rowIndex][9], 
    };
    if (loteSelecionado.situacao !== 'NÃO ENVIADO'){
      this.setState({openDialogCancelamento: true, dialogTitleCancelamento: 'Cancelamento de Lote - ' + loteSelecionado.numLotePrestador, 
      dialogMessageCancelamento: 'Deseja cancelar este Lote? Favor informar o motivo do cancelamento:', modoCancelamento: true, loteSelected: loteSelecionado});
    } else {
      this.setState({
        snackOpen: true,
        snackMessage: 'Não foi possível realizar a operação. O lote ainda não foi enviado.',
        fetching: false,
        snackSucesso: false});
    }
  }

  handleClickDesfazerCancelamento = (event, tableMeta) => {
    const loteSelecionado = {
      codLote: this.state.lotes[tableMeta.rowIndex][0],
      numLotePrestador: this.state.lotes[tableMeta.rowIndex][1],       
      situacao: this.state.lotes[tableMeta.rowIndex][9], 
    };
    this.setState({openDialogDesfazerCancelamento: true, dialogTitleCancelamento: 'Desfazer Cancelamento - ' + loteSelecionado.numLotePrestador, dialogMessageCancelamento: 'Deseja desfazer o cancelamento deste Lote?', modoCancelamento: false, loteSelected: loteSelecionado});
  }

  handleCloseDialogCancelamento = () => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false });    
  };

  handleDialogConfirmCancelamento = async (motivoCancelamento) => {
    this.setState({ openDialogCancelamento: false, openDialogDesfazerCancelamento: false, fetching: true });
    if (this.state.modoCancelamento) {
      await this.cancelarLote(motivoCancelamento);
    } else {
      await this.desfazerCancelamentoLote();
    }
  };

  cancelarLote = async (motivoCancelamento) => {
    this.setState({fetching: true});
    let lotes = [];
    lotes.push(this.state.loteSelected.codLoteGuia);

    let result;
    result = await this.faturaApi.cancelarFaturasEmLote(lotes, motivoCancelamento);
    this.onOperacaoFinalizada(result);
    await this.consultar();
    this.setState({fetching: false});
  };

  desfazerCancelamentoLote = async () => {
    this.setState({fetching: true});
    await this.faturaApi.desfazerCancelamentoLote(this.state.loteSelected.codLoteGuia);
    this.setState({fetching: false, snackOpen: true, snackMessage: 'Cancelamento desfeito com sucesso!', snackSucesso: true});
    await this.consultar();
  };

  render () {
    const { classes } = this.props;
    const { lotes, nomesLotes, numProtocoloSelected, numGuiaPrestadorSelected, numGuiaOperadoraSelected, 
      numSenhaAutorizacaoSelected, nomesFaturas, numerosDemostrativos, nomesPrestadores, nomesBeneficiarios, 
      codTipoGuiaSelected, codEstadoProtocoloSelected, codTipoLoteSelected, fetchingFilter, fetching} = this.state;    

    const options = {
      customToolbar: () => (
        <ToolbarNovo
          handleClickIncluir={this.handleClickIncluir}
        />
      ),      
      setRowProps: (row) => {
        return {
          title: (row[10] === 'S' && 'Lote Cancelado ' + row[11]),
          className:row[10] === 'S' && this.props.classes.tableRowCancelado,
        };
      },
      print: false,
      download: true,
      search: true,
      viewColumns: false,
      filter: false,
      selectableRows: 'none',
      rowsPerPageOptions: [50, 100, 150],
      rowsPerPage: 50,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline'}}>registro(s) selecionado(s)</Typography>,
        },
      }
    };
    const columns = [      
        {
          name: 'codLoteGuia',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },
        {
          name: 'Lote',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value}</Typography>;
            },
          }
        },  
        {
          name: 'Fatura',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value}</Typography>;
            },
          }
        },  
        {
          name: 'Tipo Guia',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value}</Typography>;
            },
          }
        },  
        {
          name: 'CPF/CNPJ Prestador',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value}</Typography>;
            },
          }
        },  
        {
          name: 'Nome do Prestador',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value}</Typography>;
            },
          }
        },  
        {
          name: 'Data Recebimento',
          options: {
            searchable: false,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value === null ? '-' : format(new Date(value), 'DD/MM/YYYY hh:mm:ss')}</Typography>;
            },
          }
        },
        {
          name: 'Total Processado',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (value) => {
              const nf = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              return <Typography variant='overline'>{nf.format(value)}</Typography>;
            },
          },
        },
        {
          name: 'Total Glosado',
          options: {
            filter: false,
            sort: true,
            customBodyRender: (value) => {
              const nf = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              return <Typography variant='overline' color='error'>{nf.format(value)}</Typography>;
            },
          }
        },
        {
          name: 'Situação',
          options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => {
              return <Typography variant='overline'>{value}</Typography>;
            },
          }
        },  
        {
          name: 'indCancelado',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },
        {
          name: 'motivoCancelamento',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },    
        {
          name: 'numProtocolo',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        }, 
        {
          name: 'Cancelamento',
          options: {
            filter: false,
            sort: false,
            customBodyRender: (value, tableMeta) => {
              return (
                value === 'CANCELAR'
                  ? <IconButton
                    id={'menuButton'}
                    className={classes.iconButton}
                    aria-label='More'
                    aria-owns={open ? 'long-menu' : null}
                    aria-haspopup='true'
                    title={'Cancelar o Acerto'}
                    onClick={event => this.handleClickCancelar(event, tableMeta)}
                  >
                    <ClearIcon fontSize='medium' />
                  </IconButton>
                  : value === 'DESFAZER'
                    ? <IconButton
                      id={'menuButton'}
                      className={classes.iconButton}
                      aria-label='More'
                      aria-owns={open ? 'long-menu' : null}
                      aria-haspopup='true'
                      title={'Desfazer o Cancelamento'}
                      onClick={event => this.handleClickDesfazerCancelamento(event, tableMeta)}
                    >
                      <ReplayIcon fontSize='medium' />
                    </IconButton>
                    : '-'
              );
            },
          }
        },  
        {
          name: 'Ações',
          options: {
            filter: false,
            sort: false,
            customBodyRender: (value, tableMeta) => {
              let options = [{
                index: 0,
                icon: <Print />,
                primaryText: 'Imprimir Protocolo',
                visible: true,
                disabled: false
              },
              {
                index: 1,
                icon: <VisibilityIcon />,
                primaryText: 'Ver Detalhes...',
                visible: true,
                disabled: false
              },              
              {
                index: 2,
                icon: <Send />,
                primaryText: 'Enviar p/ Faturamento...',
                visible: true,
                disabled: false
              },              
              {
                index: 3,
                icon: <TrashIcon />,
                primaryText: 'Excluir Lote...',
                visible: true,
                disabled: false
              },              
              ];
              return (
                <LongMenu
                  menuOptions={options}
                  anchorEl={this.state.anchorEl}
                  handleClick={this.handleClickMenu}
                  handleChange={this.handleChangeMenu}
                  handleClose={this.handleCloseMenu}
                  selectedItem={tableMeta} />
              );
            },
          }
        },
        {
          name: 'numDemonstrativoPag',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },
        {
          name: 'Total Liberado',
          options: {
            display: 'excluded',
            filter: false,
            sort: true,
            customBodyRender: (value) => {
              const nf = new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              return <Typography variant='overline'>{nf.format(value)}</Typography>;
            },
          },
        },
        {
          name: 'numDemonstrativoPagRecorrido',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },
        {
          name: 'dtaFimRecGlosa',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },
        {
          name: 'indLoteRecursoAuditadoPapel',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },        
        {
          name: 'historicoEstados',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },        
        {
          name: 'numProtocoloRecorrido',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },                
        {
          name: 'codTipoGuia',
          options: {
            display: 'excluded',
            filter: false,
            sort: false,
          }
        },                
      ];
    return (
      <React.Fragment>            
        <Link to='/arquivoXML' className={classes.link}>
            <Slide direction='down' timeout={600} in>
              <Paper className={classes.titlebar} elevation={1}>
                <IconButton color='inherit' aria-label='Close'>
                  <ChevronLeft />
                </IconButton>
                {this.state.nomePrestadorSelected !== undefined && this.state.nomePrestadorSelected !== ''
                ? <Typography variant='h5'>{'Lotes de Recurso de Glosa - Prestador: ' + this.state.nomePrestadorSelected}</Typography>
                : <Typography variant='h5'>{'Lotes de Recurso de Glosa'}</Typography>
              }
                <Avatar className={classes.avatar}>{lotes.length}</Avatar>
              </Paper>
            </Slide>
        </Link>
        {fetchingFilter ? <LinearProgressBlockScreen />
        :<Paper className={classes.body} elevation={0}>
            <FormControl className={classes.formControlAutoCompleteLote}>
              <IntegrationAutosuggest
                getSuggestionValue={this.getSuggestionValueLote}
                suggestions={nomesLotes}
                maxSuggestions={2}
                label={'Nº do Lote'}
              />            
            </FormControl>
              <TextField
                label='Nº Protocolo'
                type='search'
                className={classes.textFieldFilter}
                value={numProtocoloSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'numProtocoloSelected',
                }}
              /> 
              <TextField
                label='Nº Guia Prestador'
                type='search'
                className={classes.textFieldFilter}
                value={numGuiaPrestadorSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'numGuiaPrestadorSelected',
                }}
              /> 
              <TextField
                label='Nº Guia Operadora'
                type='search'
                className={classes.textFieldFilter}
                value={numGuiaOperadoraSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'numGuiaOperadoraSelected',
                }}
              /> 
              <TextField
                label='Senha de Autorização'
                type='search'
                className={classes.textFieldFilter}
                value={numSenhaAutorizacaoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'numSenhaAutorizacaoSelected',
                }}
              /> 
              <FormControl className={classes.formControlAutoCompleteFatura}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValueFatura}
                  suggestions={nomesFaturas}
                  maxSuggestions={2}
                  label={'Nº da fatura'}
                />
              </FormControl>              
              <FormControl className={classes.formControlAutoCompleteDemonstrativo}>
                <IntegrationAutosuggest
                  getSuggestionValue={this.getSuggestionValueDemonstrativo}
                  suggestions={numerosDemostrativos}
                  maxSuggestions={2}
                  label={'Número do DP...'} />
              </FormControl>              

              <Fab                
                variant='extended'
                title='Consultar'
                // disabled={this.isBuscarDisabled()}
                type='submit'
                onClick={this.handleClickBuscar}
                onTouchStart={this.handleClickBuscar}
                className={classes.buttonConsultar}>
                <Search className={classes.searchIcon} />
                Buscar
              </Fab>
              <Button
                title='Limpar'
                onClick={this.handleClickLimpar}
                onTouchStart={this.handleClickLimpar}
                className={classes.buttonLimpar}>
                <Delete className={classes.searchIcon} />
                Limpar
              </Button>
              <FormControl className={classes.formControlAutoCompletePrestador}>
                <IntegrationAutosuggest
                  disabled={this.props.codPrestador}
                  getSuggestionValue={this.getSuggestionValuePrestador}
                  suggestions={nomesPrestadores}
                  maxSuggestions={3}
                  idSelected={this.props.seqPrestador || 0}
                  nomeSelected={this.props.nomPrestador}                  
                  placeholder={'Digite o nome do prestador...'} />
              </FormControl>
              <FormControl className={classes.formControlAutoCompleteBeneficiario}>
                <FilterBeneficiario
                  beneficiarios={nomesBeneficiarios}
                  handleSelectBeneficiario={this.handleSelectBeneficiario}
                  handleClickLimpar={this.handleClickLimparCarteira}
                  maxSuggestions={3}
                />
              </FormControl>
              <FormControl className={classes.selectTipoGuia}>
                <InputLabel htmlFor='tipo-simple'>Tipo de Guia do Lote</InputLabel>
                <Select
                  value={codTipoGuiaSelected}
                  onChange={this.handleChange}
                  inputProps={{
                  name: 'codTipoGuiaSelected',
                }}
                >
                <MenuItem value={0}>TODOS</MenuItem>
                <MenuItem value={1}>Guia de Consulta</MenuItem>
                <MenuItem value={2}>Guia de SP/SADT</MenuItem>
                <MenuItem value={3}>Guia de Resumo de Internação</MenuItem>
                <MenuItem value={4}>Guia de Honorário Individual</MenuItem>
                <MenuItem value={9}>Guia de Tratamento Odontológico</MenuItem>
                </Select>
              </FormControl>              

              <FormControl className={classes.selectEstadoProtocolo}>
                <InputLabel htmlFor='tipo-simple'>Status da Fatura</InputLabel>
                  <Select
                    value={codEstadoProtocoloSelected}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'codEstadoProtocoloSelected',
                    }}
                  >
                  <MenuItem value={99}>TODOS</MenuItem>
                  <MenuItem value={0}>NÃO ENVIADO</MenuItem>
                  <MenuItem value={1}>RECEBIDO</MenuItem>
                  <MenuItem value={2}>EM ANÁLISE</MenuItem>
                  <MenuItem value={3}>ANALISADO E AGUARDANDO LIBERAÇÃO</MenuItem>
                  <MenuItem value={4}>LIBERADO PARA PAGAMENTO</MenuItem>
                  <MenuItem value={5}>ENCERRADO SEM PAGAMENTO</MenuItem>
                  <MenuItem value={6}>PAGAMENTO EFETUADO</MenuItem>
                  <MenuItem value={7}>RECEBIDO / COM AUDITORIA AUTOMÁTICA</MenuItem>                  
                </Select>
              </FormControl>
              <FormControl className={classes.selectTipoLote}>
                <InputLabel htmlFor='tipo-simple'>Somente Lotes:</InputLabel>
                  <Select
                    value={codTipoLoteSelected}
                    onChange={this.handleChange}
                    inputProps={{
                      name: 'codTipoLoteSelected',
                    }}
                  >
                  <MenuItem value={0}>TODOS</MenuItem>
                  <MenuItem value={1}>COM GLOSA</MenuItem>
                  <MenuItem value={2}>MÉDICOS SEM FATURA</MenuItem>
                  <MenuItem value={3}>ODONTOLÓGICOS AUDITADOS E SEM FAUTRA</MenuItem>
                </Select>
              </FormControl>
        </Paper>}
        {fetching ? <LinearProgressBlockScreen />
            :<Fade timeout={1000} in>          
              <Paper className={classes.body} elevation={1}>          
                <MuiThemeProvider theme={getMuiTheme()}>
                  <MUIDataTable
                    data={lotes}
                    columns={columns}
                    options={options}
                  />
                </MuiThemeProvider>
              </Paper>
            </Fade>}
        {this.state.fullScreenProtocoloOpen &&
        <FullScreenProtocolo
          open={this.state.fullScreenProtocoloOpen}
          handleClose={this.handleCloseProtocolo}
          protocolo={this.state.protocolo}
        />}
        {this.state.openDialogLote &&
          <FormDialogLoteRecurso
            open={this.state.openDialogLote}
            handleClose={this.handleDialogLoteClose}
            titulo={this.state.tituloFormDialog}
            modoInclusao={this.state.modoInclusao}
            isPrestador={this.props.isPrestador}            
            lote={this.state.loteSelected}
            numerosDemostrativos={this.state.numerosDemostrativos}
            handleSave={this.incluirLote} 
            imprimirProtocolo={this.imprimirProtocolo}
            />}
        {this.state.openDialogValidacao &&
          <DialogErrosDemonstrativos
            open={this.state.openDialogValidacao}
            handleClose={this.handleDialogValidacaoClose}
            erros={this.state.dialogContent}
            titulo={this.state.dialogTitle}
            demonstrativosSemErros={this.state.demonstrativosSemErros}
            mensagemComplementar={'foi(ram) incluído(s) com sucesso.'} />
        }            
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        <AlertDialogSlide
          open={this.state.openDialogExclusao}
          handleClose={this.handleCloseDialogExclusao}
          handleClick={this.handleDialogConfirmExclusao}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage}
          editavel
          isCPFCNPJ={this.state.clickedButton === 'excluir'}
        />
        <AlertDialogSlide
          open={this.state.openDialogEnvioFaturamento}
          handleClose={this.handleCloseDialogEnvioFaturamento}
          handleClick={this.handleDialogConfirmEnvioFaturamento}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage}
        />
        <AlertDialogSlide
          open={this.state.openDialogCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          editavel
          message={this.state.dialogMessageCancelamento} />
        <AlertDialogSlide
          open={this.state.openDialogDesfazerCancelamento}
          handleClose={this.handleCloseDialogCancelamento}
          handleClick={this.handleDialogConfirmCancelamento}
          title={this.state.dialogTitleCancelamento}
          message={this.state.dialogMessageCancelamento} />

      </React.Fragment>
    );
  }
}
export default withUsuario(withAplicacao(withStyles(styles)(LoteRecursoGlosa)));
